import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { Button } from "../components/ui/button";
import { isMuted, setMuted } from "../lib/quack";

export const MuteToggle = () => {
  const [muted, setM] = useState(isMuted());
  useEffect(() => {
    const sync = () => setM(isMuted());
    window.addEventListener("duckify-mute-change", sync);
    return () => window.removeEventListener("duckify-mute-change", sync);
  }, []);
  return (
    <Button
      variant="ghost"
      size="icon"
      className="rounded-full"
      data-testid="mute-toggle-btn"
      aria-pressed={muted}
      title={muted ? "Quack sound off — click to unmute" : "Quack sound on — click to mute"}
      onClick={() => setMuted(!muted)}
    >
      {muted ? <VolumeX className="h-5 w-5 text-muted-foreground" /> : <Volume2 className="h-5 w-5" />}
    </Button>
  );
};
